import faker from 'faker'
import moment from 'moment'
import votefriendLabels from 'assets/labels/votefriend'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: votefriendLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 120
    for (var i = 1; i <= mockTotal; i++) {
      let randNum = faker.random.number(18).toString().substr(0, 1)
      mockRows.push({
        id: i,
        codfrnid: faker.name.findName(),
        namempt: i + ': ' + faker.name.findName(),
        nickname: faker.name.findName(),
        desc_codpos: faker.name.findName(),
        score: faker.random.number(5).toString().substr(0, 1),
        remark: faker.lorem.word(),
        dtevote: moment().format('ddd MM/DD'),
        timvote: moment().format('HH:mm'),
        namimage: 'static/images/people_images/emp_image' + (randNum <= 0 ? 1 : randNum) + '.jpg'
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  save () {
    return labels.mockPostMessage
  },
  profile () {
    return {
      namempt: faker.name.findName(),
      codpos: faker.name.findName(),
      desc_codpos: faker.name.findName(),
      namimage: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/votefriend/mocker.js